import { typographyTokens } from '../../../../theme/typographyTokens';
import React from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';
import HoveredIconConfirm from '../../HoveredIconConfirmButton';
import { KnockoutFollowupExtended } from '../../../../../shared/types/Knockout';
import { useDeleteFollowupTemplateMutation } from '../../../../services/knockoutSlice';

interface FollowUpProps {
  followUp: KnockoutFollowupExtended;
}

const FollowUp = ({ followUp }: FollowUpProps) => {
  const [deleteFollowUp] = useDeleteFollowupTemplateMutation();
  const handleDelete = () => {
    deleteFollowUp(followUp.id);
  };

  return (
    <Box sx={{ paddingLeft: '30px', paddingTop: '16px' }}>
      <Stack
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            flex: 1,
          }}
        >
          <Box sx={{ paddingBottom: '15px' }}>
            <Typography
              component="div"
              sx={{ color: '#646669', fontSize: typographyTokens.fontSizes.caption, minWidth: '200px' }}
            >
              Answer
            </Typography>
            <Typography
              component="div"
              sx={{ color: '#222222', fontSize: typographyTokens.fontSizes.body }}
            >
              {followUp.value}
            </Typography>
          </Box>
          <Box
            sx={{
              flex: '0 1 auto',
              whiteSpace: 'nowrap',
              width: '100%',
              paddingBottom: '15px',
            }}
          >
            <Typography
              component="div"
              sx={{ color: '#646669', fontSize: typographyTokens.fontSizes.caption }}
            >
              Followup Type
            </Typography>
            <Typography
              component="div"
              sx={{ color: '#222222', fontSize: typographyTokens.fontSizes.body }}
            >
              <Typography
                component="span"
                sx={{ fontSize: typographyTokens.fontSizes.body, fontWeight: typographyTokens.fontWeights.bold }}
              >
                {followUp.followupType}:{` `}
              </Typography>
              {followUp.followupType === 'Task'
                ? followUp.followupTask?.name
                : followUp.followupType === 'KnockoutScreen'
                ? followUp.followupScreen?.name
                : followUp.followupStakeholder?.displayName}
            </Typography>
          </Box>
        </Box>
        <HoveredIconConfirm
          icon="fa-regular fa-trash"
          hoverIcon="fa-solid fa-trash"
          onClick={() => handleDelete()}
        />
      </Stack>
      <Divider />
    </Box>
  );
};

export default FollowUp;
